/**
 * Lightweight analytics helper. Fires events to Google Analytics (gtag) and Plausible if loaded.
 * Both providers are loaded conditionally via env vars:
 *  - REACT_APP_GA_ID (e.g. G-XXXXXXX)
 *  - REACT_APP_PLAUSIBLE_DOMAIN (e.g. euzerone.com)
 * If neither is set, calls are graceful no-ops (still logged in dev).
 */

let initialized = false;

export function initAnalytics() {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  const gaId = process.env.REACT_APP_GA_ID;
  const plausibleDomain = process.env.REACT_APP_PLAUSIBLE_DOMAIN;

  // Google Analytics 4
  if (gaId) {
    const s1 = document.createElement("script");
    s1.async = true;
    s1.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(s1);

    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", gaId, { send_page_view: true });
  }

  // Plausible
  if (plausibleDomain) {
    const s2 = document.createElement("script");
    s2.async = true;
    s2.defer = true;
    s2.setAttribute("data-domain", plausibleDomain);
    s2.src = "https://plausible.io/js/script.js";
    document.head.appendChild(s2);
  }
}

export function track(eventName, props = {}) {
  if (typeof window === "undefined") return;
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, props);
    }
    if (typeof window.plausible === "function") {
      window.plausible(eventName, { props });
    }
    if (process.env.NODE_ENV !== "production") {
      // Helpful dev visibility
      // eslint-disable-next-line no-console
      console.log("[track]", eventName, props);
    }
  } catch (e) {
    // never break UX over analytics
  }
}
